import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
// import Banner from "../assets/images/home.svg"
import Globals from '../common/Globals';
import PageNotFound from './PageNotFound';
export default function About() {
    const [showError, setpShowError] = useState(false);
    const [cmsTitle, setcmsTitle] = useState('');
    const [pContent, setpContent] = useState('');
    const [cimage, setCimage] = useState('');
    useEffect(() => {
        getData();
    }, [])
    const getData = async () => {
        await axios.get(Globals.BASE_URL + '' + Globals.CONTENT_URL + '/23', {},
            {})
            .then(function (response) {
                // console.log(response.data)
                if (response.data.status === 'ok') {
                    var count = Object.keys(response.data.cms).length;
                    if (count) {
                        // console.log(response.data.cms.pagename);
                        setcmsTitle(response.data.cms.pageheading);
                        setpContent(response.data.cms.pagecontent);
                        setCimage(response.data.cms.image);
                    } else {
                        setpShowError(true);
                    }
                } else {
                    setpShowError(true);
                }
            })
    }
    document.title = showError ? "404 - Page not found" : cmsTitle;
    document.querySelector("meta[name='description']").setAttribute('content', showError ? "404 - Page not found" : 'About us || Kaashika Wellness');
    document.querySelector("meta[name='keywords']").setAttribute('content', showError ? "404 - Page not found" : 'About us || Kaashika Wellness');
    return (
        <React.Fragment>
            {
                showError ? <PageNotFound /> :
                    <div className='PageStyle'>
                        <Container>
                            <div className='AboutmeM'>
                                <Row>
                                    <Col md="12">
                                        {
                                            cimage != null ? <img src={Globals.BASE_URL + '' + Globals.CONTENT_IMG_URL + '' + cimage} className="imgAvout" alt="" /> : ''
                                        }
                                        <h1>{cmsTitle}</h1>
                                        <div dangerouslySetInnerHTML={{ __html: pContent }}></div>
                                        <div className='clearfix '></div>
                                    </Col>
                                </Row>

                            </div>

                        </Container>
                    </div>
            }

        </React.Fragment>
    )
}
